import { useState } from 'react'
import { connect, useDispatch } from 'react-redux';
import { reduxForm, Field, change, formValueSelector } from 'redux-form';
import { Input, Select, PhoneInput, DatePicker, Textarea, MultiSelect, AutoCompleteSelect } from '../../../itrust_common/components/form'
import { getCustomLabel } from '../../../itrust_common/components/HelperFunctions';
import { SaveButton } from '../../../itrust_common/components/others';
import AutoComplete from '../../../itrust_common/components/others/AutoComplete';
import { patientLoad } from '../../../redux/actions/patient/patientActions';
import PatientInfo from './PatientInfo'
import { email, required } from '../../../itrust_common/components/form/FormValidations';
import { lowercase, capitalizeFirstLetter } from '../../../itrust_common/components/form/FormNormalize';
import ScrollToTarget from '../../../itrust_common/components/others/ScrollToTarget';
import { onBoardingTourInfoUpdate } from '../../../redux/actions/onBoardingActions';
import PatientModeOfNotification from '../../../itrust_common/components/form/PatientModeOfNotification';
import { STATUSES } from '../../../itrust_common/components/Constants';
import AppointmentStartEndTime from './AppointmentStartEndTime';
import TabAppointment from './TabAppointment';
import { useEffect } from 'react';
import PatientSearch from './PatientSearch';

function NewAppointmentForm(props) {
  const { staffs, appointment, handleSubmit, handleAppointmentEditHandler, patient, saving, formType, procedures, isFullMode, selectedVisionInsuranceId, selectedMedicalInsuranceId, visionInsuranceTemplate, medicalInsuranceTemplate, onBoarding: { isTourActive, stepIndex, activeTourType }, isQuickAction, patientBasicDetailsTemplate } = props
  const dispatch = useDispatch()
  const [requireInsurance, setRequireInsurance] = useState({ vision: false, medical: false })

  useEffect(() => {
    handleSearchResultClose()
  }, [])

  useEffect(() => {
    if (isTourActive && activeTourType === 'create_appointment') {
      handleAppointmentTour()
    }
  }, [isTourActive, activeTourType])

  const handlePatientLoad = (id) => {
    dispatch(patientLoad(id, { include: ['patient_medical_insurance', 'patient_vision_insurance'] }))
  }

  const handleSearchResult = (id) => {
    handlePatientLoad(id)
    handleAppointmentEditHandler({ formType: 'existing' })
    dispatch(change('appointmentForm', 'patient_id', id))
  }

  const handleSearchResultClose = () => {
    handleAppointmentEditHandler({ formType: 'default' });
    dispatch(change('appointmentForm', 'patient_id', ''))
  }

  const handleIsFieldRequired = (fieldName, isValidation) => {
    return patientBasicDetailsTemplate?.[fieldName]?.required ? isValidation ? [required] : '*' : ''
  }

  const handleAppointmentTour = () => {
    if (formType !== 'default') {
      // existing and new // move to step reason for visit
      stepIndex !== 2 && dispatch(onBoardingTourInfoUpdate({ stepIndex: 2, isTourActive: true, activeTourType: 'create_appointment' }))
    }
    else {
      // default
      stepIndex !== 1 && dispatch(onBoardingTourInfoUpdate({ stepIndex: 1, isTourActive: true, activeTourType: 'create_appointment' }))
    }
  }

  const handleOnInsuranceChange = (data, insurance_type) => {
    let newVal = { [insurance_type]: data?.require_member_id };
    if (!!visionInsuranceTemplate.member_id.required) { // boolean conversion
      newVal = { ...newVal, vision: true }
    }
    if (!!medicalInsuranceTemplate.member_id.required) { // boolean conversion
      newVal = { ...newVal, medical: true }
    }
    setRequireInsurance(prevState => ({ ...prevState, ...newVal }))
    return true
  }

  return (
    <form onSubmit={handleSubmit} className={`appointment-step-2 ${isFullMode && 'overflow-auto overflow-x-hidden height-54'}`}>
      <TabAppointment staffs={staffs} isNew={true} tab_appointment={appointment.tab_appointment} />
      <div className="modal-body px-5 pt-1 pb-0">
        <AppointmentStartEndTime procedures={procedures} isQuickAction={isQuickAction} />
        {formType === 'default' &&
          <PatientSearch
            dispatch={dispatch}
            handleAppointmentEditHandler={handleAppointmentEditHandler}
          />
        }
        {formType === 'existing' &&
          <div className="modal-body p-0">
            <PatientInfo patient={patient} handleSearchResultClose={handleSearchResultClose} />
          </div>
        }
        {(formType === 'new' && !isFullMode) && <div className="selected-patient">
          <div className="row w-100 m-0">
            <Field name="first_name" placeholder={`First Name ${handleIsFieldRequired("first_name")}`} component={Input} className="form-control" wrapperClasses="form-group col-6 pl-0 pr-3" validate={!isFullMode && required} normalize={capitalizeFirstLetter} />
            <Field name="last_name" placeholder={`Last Name ${handleIsFieldRequired("last_name")}`} component={Input} className="form-control" wrapperClasses="form-group col-6 pl-3 pr-0" normalize={capitalizeFirstLetter} validate={handleIsFieldRequired("last_name", true)} />
            <Field name="date_of_birth" component={DatePicker} wrapperClasses="form-group col-12 px-0" validate={handleIsFieldRequired('date_of_birth', true)} />
            <Field name="cell_phone" component={PhoneInput} className="form-control" wrapperClasses="form-group col-6 pl-0 pr-3" validate={handleIsFieldRequired('cell_phone', true)} />
            <Field name="email" normalize={lowercase} placeholder={`Email ${handleIsFieldRequired("email")}`} component={Input} className="form-control" wrapperClasses="form-group col-6 pl-3 pr-0" validate={[email, ...handleIsFieldRequired("email", true)]} />
            <Field
              name="patient_vision_insurance_attributes[settings_insurance_id]"
              label={visionInsuranceTemplate && getCustomLabel(visionInsuranceTemplate, 'insurance')}
              component={AutoCompleteSelect}
              textField="name"
              valueField="id"
              klass="Settings::Insurance"
              filter={{ insurance_type: 'vision' }}
              onSelectChange={(data) => handleOnInsuranceChange(data, 'vision')}
              wrapperClasses={`${(selectedVisionInsuranceId !== null && selectedVisionInsuranceId !== undefined) ? 'col-6' : 'col-12'} form-group px-0`}
            />
            {(selectedVisionInsuranceId !== null && selectedVisionInsuranceId !== undefined) &&
              <Field name="patient_vision_insurance_attributes[member_id]" component={Input} label="Member ID" className="form-control" wrapperClasses="col-6 form-group pe-0" validate={requireInsurance.vision ? [required] : []} />
            }
            <Field
              name="patient_medical_insurance_attributes[settings_insurance_id]"
              label={medicalInsuranceTemplate && getCustomLabel(medicalInsuranceTemplate, 'insurance')}
              component={AutoCompleteSelect}
              textField="name"
              valueField="id"
              onSelectChange={(data) => handleOnInsuranceChange(data, 'medical')}
              klass="Settings::Insurance"
              filter={{ insurance_type: 'medical' }}
              wrapperClasses={` ${(selectedMedicalInsuranceId !== null && selectedMedicalInsuranceId !== undefined) ? 'col-6' : 'col-12'} form-group px-0`}
            />
            {(selectedMedicalInsuranceId !== null && selectedMedicalInsuranceId !== undefined) &&
              <Field name="patient_medical_insurance_attributes[member_id]" component={Input} label="Member ID" className="form-control" wrapperClasses="col-6 form-group pe-0" validate={requireInsurance.medical ? [required] : []} />
            }
            <PatientModeOfNotification
              label={<span>Mode of Notification <span className="text-danger">{handleIsFieldRequired('mode_of_notification_type')}</span></span>}
              formName="appointmentForm"
              name="mode_of_notification_type"
              wrapperClasses="col-8 form-group px-0"
            />
          </div>
        </div>
        }
      </div>
      {(formType !== 'default') &&
        <div className="row w-100 m-0 px-5">
          <MultiSelect key={`appointment-${appointment.id}-procedures`} name="procedure_ids"
            placeholder="Reason For Visit *"
            data={procedures}
            defaultValues={appointment.procedure_ids}
            textField="friendly_name"
            valueField="settings_procedure_id"
            isAllSelectVisible={false}
            isSearchVisible={true}
            onSelectHook={(value) => dispatch(change('appointmentForm', 'procedure_ids', value))}
            wrapperClasses="col-12 form-group px-0 appointment-step-3"
          />
          <Field name="comment" rows={1} component={Textarea} label="Comments" className="form-control" wrapperClasses="col-12 form-group px-0" />
        </div>
      }
      <Field label="Status" name="status" component={Select} textField="text" valueField="value" data={STATUSES} wrapperClasses="w-100 m-2 px-5 pb-6" />
      {isFullMode && <div className="modal-footer px-5 pb-7 pt-0 border-0">
        {formType === 'default' ?
          <a className="btn btn-link text-primary" onClick={() => handleAppointmentEditHandler({ formType: 'new' })}>Add New Patient</a> :
          !isTourActive && <button type="button" className="btn btn-link" onClick={() => { handleAppointmentEditHandler({ isFullMode: true }); }}>
            Full Mode
          </button>
        }
        <SaveButton buttonClasses={`${formType === 'default' && 'disabled'}`} saving={saving} />
      </div>}
    </form>
  )
}

NewAppointmentForm = reduxForm({
  form: 'appointmentForm',
  enableReinitialize: true,
  shouldValidate: () => true,
  onSubmitFail: (errors) => ScrollToTarget()
})(NewAppointmentForm);

const selector = formValueSelector('appointmentForm');

const mapStateToProps = state => {
  const { currentStore, appointment, setting: { patientTemplate: { patient_template }, calendarSetting }, organisation } = state
  const patientInsuranceData = patient_template.personal_information?.insurance_detail?.fields
  const selectedVisionInsuranceId = selector(state, 'patient_vision_insurance_attributes[settings_insurance_id]')
  const selectedMedicalInsuranceId = selector(state, 'patient_medical_insurance_attributes[settings_insurance_id]')
  const timeSlotFrequency = calendarSetting.calendar_setting.time_slot_frequency
  const staffIds = currentStore.staffs?.map(staff => staff.id) || []
  return {
    visionInsuranceTemplate: patientInsuranceData?.vision_insurance?.fields,
    medicalInsuranceTemplate: patientInsuranceData?.medical_insurance?.fields,
    staffs: currentStore.staffs,
    appointment: appointment,
    formType: appointment.handlerData.formType,
    selectedVisionInsuranceId,
    selectedMedicalInsuranceId,
    patientBasicDetailsTemplate: patient_template.personal_information.basic_details.fields,
    initialValues: {
      // staff_id: currentStore.store.default_provider_id,
      staff_id: (currentStore.store.default_provider_id && staffIds.includes(currentStore.store.default_provider_id) ? currentStore.store.default_provider_id : ''),
      ...appointment.appointment,
      mode_of_notification_type: patient_template.personal_information.basic_details?.fields?.mode_of_notification_type.default_value,
      start_time: appointment.appointment.start_time,
      end_time: new Date(appointment.appointment.start_time.getTime() + timeSlotFrequency * 60000),
    }
  }
}

export default connect(mapStateToProps)(NewAppointmentForm);